<template>
  <!-- Modal -->
  <div>
    <div class="modal fade" ref="vuemodal" id="ArchivePaymentsModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">{{translations('common.addition')}}</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>{{translations('deposit.billing_data')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <tr>
                  <td>
                    <select class="custom-select" v-model="selectedID">
                      <option selected>-</option>
                      <option
                        v-for="(billing, i) in billingData.list"
                        :key="i"
                        :value="billing.id"
                      >{{ billing.name + ' （' + $invoiceTools.formatDateAt(billing.billed_at) + '）' }}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <div>
              <button ref="closeBillingModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>&nbsp;
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                data-toggle="modal"
                data-target="#ArchivePaymentsModal2"
                @click="selectBillingData()"
              >{{translations('common.next')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ArchivePaymentsModal2 :billingData="selectedBillingData"/>
  </div>
</template>

<script>
import ArchivePaymentsModal2 from '@/components/ArchivePaymentsModal2'
import { mapState } from 'vuex'
export default {
  name: 'ArchivePaymentsModal',
  props: {},
  components: {
    ArchivePaymentsModal2
  },
  data () {
    return {
      billingData: [],
      selectedID: null,
      selectedBillingData: {
        id: '',
        name: ''
      }
    }
  },
  created () {
    this.getBillingSimpleData()
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('hidden.bs.modal', this.clearDetails)
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    clearDetails () {
      this.selectedID = null
    },
    async getBillingSimpleData () {
      try {
        await this.$http.post(this.$api_url.billing_simple_list).then(billing => {
          if (billing.data && billing.data.status === true) {
            this.billingData = billing.data
          } else {
            if (billing.data.message) {
              this.$toastr.error(billing.data.message, this.translations('common.error'))
            } else {
              this.$toastr.error(billing.data, this.translations('common.error'))
            }
            this.billingData = []
          }
        })
      } catch (error) {
        this.billingData = []
        console.log('ArchiveSales:API:billingSimpleList:error: ', error)
      }
    },

    selectBillingData () {
      this.billingData.list.forEach(val => {
        if (val.id === parseInt(this.selectedID)) {
          this.selectedBillingData = val
        }
      })
    }
  }
}
</script>
